import _createForOfIteratorHelper from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { canUseDOM, isChina, getGlobalDictionaryTerm, get, getPageThemeColors } from '../../../utils';
import { getUserCookie, getLatestUserCookie } from '../../Login/user_session';
import IconHeartLine from '../../../components/atoms/Icons/IconHeartLine';
import IconHeartFilled from '../../../components/atoms/Icons/IconHeartFilled';
import { syncTopPicks, getEmptyTopPicksStorage, getTopPicks, getTopPicksStorage, setTopPicksStorage, addTopPicks, removeTopPicks } from './top_picks_apis';
export var idConverter = function idConverter(id) {
  id = id.toLowerCase();
  if (id.length === 36) {
    return id;
  } else if (id.length === 32) {
    return "".concat(id.substr(0, 8), "-").concat(id.substr(8, 4), "-").concat(id.substr(12, 4), "-").concat(id.substr(16, 4), "-").concat(id.substr(20));
  } else if (id.length === 38) {
    return "".concat(id.substr(1, 36));
  }
};
var FavouriteBtn = function FavouriteBtn(_ref) {
  var classes = _ref.classes,
    itemId = _ref.itemId,
    callback = _ref.callback,
    checkFavouriteButton = _ref.checkFavouriteButton,
    analyticsClick = _ref.analyticsClick,
    componentPrimaryColor = _ref.componentPrimaryColor,
    componentPrimaryColorActive = _ref.componentPrimaryColorActive,
    _ref$multiplyButton = _ref.multiplyButton,
    multiplyButton = _ref$multiplyButton === void 0 ? false : _ref$multiplyButton,
    activeListOnSamePage = _ref.activeListOnSamePage,
    _ref$isListing = _ref.isListing,
    isListing = _ref$isListing === void 0 ? false : _ref$isListing;
  var additionalClasses = classes || '';
  var storageName = 'top-picks';
  var loginPopupCookieName = 'login_popup';
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    connectedState = _useState2[0],
    setConnectedState = _useState2[1];
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var addToFavorites = getGlobalDictionaryTerm(sitecoreContext, 'addToFavorites') || 'add To Favorites';
  var removeFromFavorites = getGlobalDictionaryTerm(sitecoreContext, 'removeFromFavorites') || 'remove from Favorites';
  var identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  var clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  var apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'https://replaceapiGlobal';
  var clientSecret = get(sitecoreContext, 'configuration.globalApi.clientSecret') || 'replacesecret';
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var variables = componentPrimaryColor && !isListing ? {
    '--favorite-btn-primary-color': componentPrimaryColor,
    '--favorite-btn-active-primary-color': componentPrimaryColorActive
  } : {
    '--favorite-btn-primary-color': primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    '--favorite-btn-active-primary-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary
  };
  var topPicksList = {
    list: []
  };
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    active = _useState4[0],
    setActive = _useState4[1];
  var id;
  if (itemId) {
    id = idConverter(itemId);
  }
  var updateStateForFirstLoad = function updateStateForFirstLoad() {
    var topPicks = getTopPicksStorage();
    var topPicksList = topPicks.list || [];
    if (topPicksList && topPicksList.length) {
      var _iterator = _createForOfIteratorHelper(topPicksList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.itemId === id) {
            setActive(true);
            break;
          } else if (active) {
            setActive(false);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    if (topPicksList) {
      if (topPicksList.length) {
        if (canUseDOM) document.body.classList.add('has--favourites');
      }
    }
  };
  useEffect(function () {
    if (getUserCookie().login_status) {
      setTimeout(function () {
        updateStateForFirstLoad();
      }, 800);
    } else {
      updateStateForFirstLoad();
    }
  }, [itemId]);
  useEffect(function () {
    if (multiplyButton) {
      if (activeListOnSamePage) {
        if (activeListOnSamePage.includes(id)) {
          setActive(true);
        } else if (active) {
          setActive(false);
        }
      }
    }
  }, [activeListOnSamePage, multiplyButton]);

  // useEffect(() => {

  //   // toggleInner();
  //   setTimeout(() => {
  //     updateStateForFirstLoad();
  //   }, 1000);
  // }, [checkFavouriteButton]);
  if (canUseDOM) {
    var urlParams = new URLSearchParams(document.location.search);
    var isC = Boolean(urlParams.get('isChina') === 'true');
    if (isC) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
  }
  var loginPopupCheck = function loginPopupCheck() {
    if (!getUserCookie().login_status) {
      var loginPopupCookie = Cookies.get(loginPopupCookieName);
      if (loginPopupCookie === undefined) {
        if (canUseDOM) {
          document.body.classList.add('lr-popup--open');
          var popup = document.querySelector('.lr-popup');
          if (popup) {
            var focusableInner = popup.querySelector('a, button, [tabindex="0"]');
            if (focusableInner) {
              focusableInner.focus();
            }
          }
        }
      }
    }
  };
  var topPicksAddition = function topPicksAddition(id) {
    return new Promise(function (resolve) {
      if (getUserCookie().login_status) {
        getLatestUserCookie(identityGlobal, clientId, clientSecret).then(function (userCookie) {
          if (userCookie.login_status) {
            if (userCookie.error) {
              resolve(false);
            } else {
              addTopPicks(userCookie.access_token, [id], apiGlobal).then(function (state) {
                if (state.success) {
                  resolve(true);
                } else {
                  resolve(false);
                }
              });
            }
          } else {
            resolve(false);
          }
        });
      } else {
        resolve(false);
      }
    });
  };
  var topPicksRemoval = function topPicksRemoval(id) {
    return new Promise(function (resolve) {
      if (getUserCookie().login_status) {
        getLatestUserCookie(identityGlobal, clientId, clientSecret).then(function (userCookie) {
          if (userCookie.login_status) {
            if (userCookie.error) {
              resolve(false);
            } else {
              removeTopPicks(userCookie.access_token, [id], apiGlobal).then(function (state) {
                if (state.success) {
                  resolve(true);
                } else {
                  resolve(false);
                }
              });
            }
          } else {
            resolve(false);
          }
        });
      } else {
        resolve(false);
      }
    });
  };
  var addDisconnectedItems = function addDisconnectedItems(topPicksList, id) {
    var foundInRemoved = false;
    topPicksList.removed = topPicksList.removed.filter(function (item) {
      if (item !== id) {
        return true;
      } else {
        foundInRemoved = true;
      }
    });
    if (!foundInRemoved) {
      topPicksList.added.push(id);
    }
    return topPicksList;
  };
  var removeDisconnectedItems = function removeDisconnectedItems(topPicksList, id) {
    var foundInAdded = false;
    topPicksList.added = topPicksList.added.filter(function (item) {
      if (item !== id) {
        return true;
      } else {
        foundInAdded = true;
      }
    });
    if (!foundInAdded) {
      topPicksList.removed.push(id);
    }
    return topPicksList;
  };
  var toggleBodyClass = function toggleBodyClass(list) {
    if (canUseDOM) {
      if (list && list.length) {
        document.body.classList.add('has--favourites');
      } else {
        document.body.classList.remove('has--favourites');
      }
    }
  };
  var toggleInner = function toggleInner() {
    var topPicksList = getTopPicksStorage();
    if (active) {
      topPicksRemoval(id).then(function (status) {
        topPicksList.sync = status;
        topPicksList.list = topPicksList.list.filter(function (item) {
          return item.itemId === id ? false : true;
        });
        if (!status) {
          topPicksList = removeDisconnectedItems(topPicksList, id);
        }
        setTopPicksStorage(topPicksList);
        toggleBodyClass(topPicksList.list);
      });
    } else {
      topPicksAddition(id).then(function (status) {
        topPicksList.sync = status;
        topPicksList.list.push({
          itemId: id
        });
        if (!status) {
          topPicksList = addDisconnectedItems(topPicksList, id);
        }
        setTopPicksStorage(topPicksList);
        toggleBodyClass(topPicksList.list);
      });
    }
    setActive(!active);
    if (callback) {
      callback(id);
      setActive(true);
    }
  };

  // Toggle Fav State and add/remove in cookie
  var toggleFavourite = function toggleFavourite() {
    loginPopupCheck();
    // callback(id)

    var topPicksList = getTopPicksStorage();
    if (topPicksList.sync) {
      toggleInner();
    } else {
      getLatestUserCookie(identityGlobal, clientId, clientSecret).then(function (userCookie) {
        if (userCookie.login_status) {
          syncTopPicks(userCookie.access_token, apiGlobal).then(function (result) {
            if (result) {
              getTopPicks(userCookie.access_token, apiGlobal).then(function (topPicks) {
                if (!topPicks.failed) {
                  setTopPicksStorage(getEmptyTopPicksStorage(topPicks));
                  toggleInner();
                } else {
                  toggleInner();
                }
              });
            } else {
              toggleInner();
            }
          });
        } else {
          toggleInner();
        }
      });
    }
  };
  if (!isChina()) {
    var titleForButton = active ? removeFromFavorites : addToFavorites;
    return /*#__PURE__*/React.createElement("button", {
      style: variables,
      className: "global-fav-button my-icon-white ".concat(additionalClasses),
      "aria-label": titleForButton,
      onClick: function onClick() {
        // if (callback) {

        // };
        if (analyticsClick) {
          analyticsClick(titleForButton, active);
        }
        toggleFavourite();
      },
      onKeyPress: function onKeyPress(event) {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          if (analyticsClick) {
            analyticsClick(titleForButton, active);
          }
          toggleFavourite();
        }
      }
    }, /*#__PURE__*/React.createElement("span", {
      hidden: true
    }, titleForButton), active ? /*#__PURE__*/React.createElement(IconHeartFilled, {
      className: "icon"
    }) : /*#__PURE__*/React.createElement(IconHeartLine, {
      className: "icon"
    }));
  }
  return /*#__PURE__*/React.createElement("div", null);
};
export default FavouriteBtn;